const TOC_ANCHORS = {
    MANAGEMENT_SUMMARY: "toc-management-summary",
    COMPANY_OVERVIEW: "toc-company-overview",
    SECTION_1: "toc-section-1",
    SECTION_1_1: "toc-section-1-1",
    SECTION_1_2: "toc-section-1-2",
    SECTION_1_3: "toc-section-1-3",
    SECTION_1_4: "toc-section-1-4",
    SECTION_1_5: "toc-section-1-5",
    SECTION_1_6: "toc-section-1-6",
    SECTION_2: "toc-section-2",
    SECTION_2_1: "toc-section-2-1",
    SECTION_2_2: "toc-section-2-2",
    SECTION_2_3: "toc-section-2-3",
    SECTION_2_4: "toc-section-2-4",
    SECTION_2_5: "toc-section-2-5",
    SECTION_2_6: "toc-section-2-6",
    SECTION_2_7: "toc-section-2-7",
    SECTION_2_8: "toc-section-2-8",
    SECTION_2_9: "toc-section-2-9",
    SECTION_2_10: "toc-section-2-10",
    SECTION_2_11: "toc-section-2-11",
    SECTION_3: "toc-section-3",
    SECTION_4: "toc-section-4",
    SECTION_5: "toc-section-5",
    SECTION_6: "toc-section-6",
    SECTION_6_1: "toc-section-6-1",
    SECTION_6_2: "toc-section-6-2",
    SECTION_7: "toc-section-7",
    SECTION_8: "toc-section-8",
    SECTION_9: "toc-section-9",
    SECTION_10: "toc-section-10",
    SECTION_11: "toc-section-11",
};

const SUPPLIER_REPORT_TOC_ENTRIES = [
    {
        title: "Management Summary",
        anchorId: TOC_ANCHORS.MANAGEMENT_SUMMARY,
    },
    {
        title: "Company Overview",
        anchorId: TOC_ANCHORS.COMPANY_OVERVIEW,
    },
    {
        title: "Basic Company Information",
        number: "1",
        anchorId: TOC_ANCHORS.SECTION_1,
        children: [
            { title: "Address", number: "1.1.", anchorId: TOC_ANCHORS.SECTION_1_1 },
            { title: "Contact Information", number: "1.2.", anchorId: TOC_ANCHORS.SECTION_1_2 },
            { title: "Shareholders", number: "1.3.", anchorId: TOC_ANCHORS.SECTION_1_3 },
            { title: "Management Team", number: "1.4.", anchorId: TOC_ANCHORS.SECTION_1_4 },
            { title: "Financial Summary", number: "1.5.", anchorId: TOC_ANCHORS.SECTION_1_5 },
            { title: "Metadata", number: "1.6.", anchorId: TOC_ANCHORS.SECTION_1_6 },
        ],
    },
    {
        title: "External Company Information",
        number: "2",
        anchorId: TOC_ANCHORS.SECTION_2,
        children: [
            { title: "Download Details", number: "2.1.", anchorId: TOC_ANCHORS.SECTION_2_1 },
            { title: "Executive Summary", number: "2.2.", anchorId: TOC_ANCHORS.SECTION_2_2 },
            { title: "Company Identification & Status", number: "2.3.", anchorId: TOC_ANCHORS.SECTION_2_3 },
            { title: "Address", number: "2.4.", anchorId: TOC_ANCHORS.SECTION_2_4 },
            { title: "Management", number: "2.5.", anchorId: TOC_ANCHORS.SECTION_2_5 },
            { title: "Financial Overview", number: "2.6.", anchorId: TOC_ANCHORS.SECTION_2_6 },
            { title: "Group Structure", number: "2.7.", anchorId: TOC_ANCHORS.SECTION_2_7 },
            { title: "Bankers And Advisors", number: "2.8.", anchorId: TOC_ANCHORS.SECTION_2_8 },
            { title: "Employee Information", number: "2.9.", anchorId: TOC_ANCHORS.SECTION_2_9 },
            { title: "Share Capital Information", number: "2.10.", anchorId: TOC_ANCHORS.SECTION_2_10 },
            { title: "Shareholder Information", number: "2.11.", anchorId: TOC_ANCHORS.SECTION_2_11 },
        ],
    },
    {
        title: "Group Structure Graph",
        number: "3",
        anchorId: TOC_ANCHORS.SECTION_3,
    },
    {
        title: "Compliance Monitoring",
        number: "4",
        anchorId: TOC_ANCHORS.SECTION_4,
    },
    {
        title: "Compliance Screening",
        number: "5",
        anchorId: TOC_ANCHORS.SECTION_5,
    },
    {
        title: "Products",
        number: "6",
        anchorId: TOC_ANCHORS.SECTION_6,
        children: [
            { title: "Products Detail", number: "6.1.", anchorId: TOC_ANCHORS.SECTION_6_1 },
            { title: "Deforestation Due Diligence", number: "6.2.", anchorId: TOC_ANCHORS.SECTION_6_2 },
        ],
    },
    {
        title: "Findings",
        number: "7",
        anchorId: TOC_ANCHORS.SECTION_7,
    },
    {
        title: "Related Incidents",
        number: "8",
        anchorId: TOC_ANCHORS.SECTION_8,
    },
    {
        title: "Reports",
        number: "9",
        anchorId: TOC_ANCHORS.SECTION_9,
    },
    {
        title: "Risk Assessment",
        number: "10",
        anchorId: TOC_ANCHORS.SECTION_10,
    },
    {
        title: "Task Management",
        number: "11",
        anchorId: TOC_ANCHORS.SECTION_11,
    },
];

export { TOC_ANCHORS, SUPPLIER_REPORT_TOC_ENTRIES };
